/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnaireConfigInvestmentProfile
 */
export interface QuestionnaireConfigInvestmentProfile {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigInvestmentProfile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigInvestmentProfile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigInvestmentProfile
     */
    description: string;
}

/**
 * Check if a given object implements the QuestionnaireConfigInvestmentProfile interface.
 */
export function instanceOfQuestionnaireConfigInvestmentProfile(value: object): value is QuestionnaireConfigInvestmentProfile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function QuestionnaireConfigInvestmentProfileFromJSON(json: any): QuestionnaireConfigInvestmentProfile {
    return QuestionnaireConfigInvestmentProfileFromJSONTyped(json, false);
}

export function QuestionnaireConfigInvestmentProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireConfigInvestmentProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
    };
}

export function QuestionnaireConfigInvestmentProfileToJSON(json: any): QuestionnaireConfigInvestmentProfile {
    return QuestionnaireConfigInvestmentProfileToJSONTyped(json, false);
}

export function QuestionnaireConfigInvestmentProfileToJSONTyped(value?: QuestionnaireConfigInvestmentProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

